import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Tag,
  Pagination,
  Dropdown,
  Menu,
  Spin,
  Form,
  Select,
  message,
  Modal,
  Radio,
  Row,
  Col,
} from "antd";
import { connect } from "react-redux";
import Highlighter from "react-highlight-words";
import _ from "lodash";
import {
  ConsoleSqlOutlined,
  SearchOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";
import { professionalAction, userActions } from "../../_actions";
import { ImageView } from "../image/imageView";
import { LanguageContext } from "../../context/LanguageContext";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";
import FindAccusedBaseSearchTable from "./FindAccusedBaseSearchTable";
import FilterData from "../../_components/FilterData";
import moment from "moment";
import * as XLSX from "xlsx-js-style";
import { roleAction } from "../../_actions/roleby.action";
const { Option } = Select;

class FindAccusedBaseTable extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.state = {
      imageOpen: false,
      searchText: "",
      searchedColumn: "",
      total: 0,
      pageSize: 10,
      currentPage: 0,
      criminalList1: [],
      data: [],
      orderDirection: "",
      search: false,
      tableLoading: false,
      isLoading: false,
      crimeTitle: [],
      selectedHeadings: [],
      isFilterActive: false,
      filterData: [],
      imageOpen: false,
      selectedImage: null,
      name: null,
      showGunaDetails: false,
      gunaLoading: false,
      download: "excel",
      selectedYear: false,
      year: [],
      is_photo: false,
      photoStatus: "",
      select_dropdown: "search_name",
      is_download: false,
      kayda: "",
      kalam: [],
      main_head: [],
      select_main_head: "",
      crime_type: [],
    };
  }

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
  };
  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  download_csv = () => {
    const { t, language } = this.context;
    const { showList } = this.state;
    const report_name = "Accused_Details";

    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

    const ReportTitle = "Accused_Details";

    let list = [];
    list =
      this.state.filterData &&
      this.state.filterData.map((data, index) => ({
        [t("sr.no")]: index + 1,
        [t("name")]: data.name ? data.name : "-",
        [t("age")]: data.age ? data.age : "-",
        [t("total_crimes")]: data.totalCrimeCount ? data.totalCrimeCount : "-",
        [t("accused_police_station")]: data.districtName,
        [this.state.selectedFilter === "शीर्षक" ? t("title") : t("sub_title")]:
          data?.headingNames?.length > 0
            ? data.headingNames.join(", ")
            : data?.crime_titles?.length > 0
            ? data.crime_titles.join(", ")
            : "",

        [t("photo")]:
          data?.photo?.length > 0 && data.photo[0] !== "" ? t("yes") : t("no"),
      }));
    console.log("list", list);

    var arrData = list;

    console.log("arrData", arrData);

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length)
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const headerStyle = {
      font: { bold: true, sz: 12 },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };
    const cellStyle = {
      font: { sz: 12 },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };
    Object.keys(arrData[0]).forEach((key, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: index }); // Headers are at row 3 (A3)
      if (!ws[cellRef]) ws[cellRef] = {}; // Ensure cell exists
      ws[cellRef].s = headerStyle;
    });
    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((value, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        }); // Data starts at row 4
        if (!ws[cellRef]) ws[cellRef] = {};
        ws[cellRef].s = cellStyle;
      });
    });

    ws["A1"] = {
      v: this.getCityName(this.props?.user?.cityId || ""),
      t: "s",
      s: headerStyle,
    };
    ws["A2"] = { v: ReportTitle, t: "s", s: headerStyle };
    console.log("language", language);

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { bold: true, sz: 12, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];

    mergeRanges.push({
      s: { r: 2, c: 0 },
      e: { r: 2, c: columnWidths.length - 1 },
    });

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  showGunaViewModel = () => {
    this.setState({
      showGunaDetails: true,
    });
  };
  closeGunaViewModel = () => {
    this.setState({
      showGunaDetails: false,
    });
  };
  onGunaForm = (data) => {
    if (data) {
      this.setState({ gunaLoading: true });
      this.showGunaViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  openImageModal = (img, name) => {
    this.setState({ imageOpen: true, selectedImage: img, name: name });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null, name: null });
  };
  componentDidMount() {
    console.log("this.props", this.props);
    if (this.props && this.props?.data) {
      console.log("in if");
    }
    this.getMainHead();
  }

  clear = () => {
    this.setState({
      filter: false,
      gunacount: false,
      searchText: "",
      search: false,
      issearch: false,
      total: 0,
    });
  };

  clearFilter = () => {
    this.setState({
      filter: false,
      gunacount: false,
      searchText: "",
      search: false,
      issearch: false,
      isFilterActive: false,
      crimeTitle: [],
      selectedHeadings: [],
      selectedFilter: "",
      filterData: [],
      year: [],
      is_year: false,
      total: 0,
      is_photo: false,
      photoStatus: null,
      is_guna: false,
      searchGuna: "",
      kayda: "",
      kalam: [],
      select_main_head: "",
      crime_type:[],
    });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={(e) => {
              this.handleSearch(selectedKeys, confirm, dataIndex);
              if (
                this.props &&
                (this.props?.report === true ||
                  this.props?.ongoing === true ||
                  this.props?.completed === true)
              ) {
                this.searchDataReport(this.state.searchText);
              } else {
                this.searchdata(selectedKeys[0]);
              }
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              this.handleReset(clearFilters);
              this.clear();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    // onFilter: (value, record) =>
    //   record[dataIndex]
    //     ? record[dataIndex]
    //         .toString()
    //         .toLowerCase()
    //         .includes(value.toLowerCase())
    //     : "",
    // onFilterDropdownVisibleChange: (visible) => {
    //   if (visible) {
    //     setTimeout(() => this.searchInput.select(), 100);
    //   }
    // },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = async (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys,
      searchedColumn: dataIndex,
    });
  };

  searchdata = () => {
    const { currentPage, pageSize } = this.state;
    this.setState({ currentPage: 0, search: true, isLoading: true });
    this.setState({ issearch: true });
    if (this.state.searchText) {
      if (this.props.user.role === "4")
        professionalAction
          .getCriminalsAppInfoByCitySerach(
            this.props.cityid,
            this.state.searchText,
            currentPage,
            pageSize
          )
          .then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.dataItem;

                // Map and assign updated array
                list = list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                    "Sr.No": this.getSerialNumber(index, currentPage, pageSize),
                  };
                });

                console.log("search list", list);

                this.setState({
                  criminalList1: list,
                  isLoading: false,
                  total: criminal.totalItems,
                  issearch: true,
                });
              });
          });
    }
    if (this.props.user.role === "9" || this.props.user.role === "10") {
      const temp = {
        districtIds: this.props.user.map_districtId,
        search: this.state.searchText,
        page: currentPage,
        size: pageSize,
      };
      roleAction.getCriminalsAppInfoSearchByrole(temp).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.dataItem;
            this.setState({
              criminalList1: list,
              isLoading: false,
              total: criminal.totalItems,
              issearch: true,
            });
          });
      });
    }
  };

  searchDataReport = () => {
    if (this.props?.report === true) {
      this.getDefaultReport();
    } else if (this.props?.ongoing === true) {
      this.getOngoingSearchReport();
    } else if (this.props?.completed === true) {
      this.getCompletedSearchReport();
    }
  };

  getDefaultReport = () => {
    if (this.state.searchText) {
      professionalAction
        .getSearchPreventiveList(
          this.props.startDate,
          this.props.endDate,
          this.props.cityid,
          this.state.searchText,
          this.props.preventive_action
        )
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;
              this.setState({
                criminalList1: list,
                isLoading: false,
                total: criminal.totalItems,
              });
              this.isLoading = false;
            });
        });
      this.setState({
        criminalList1: [],
        filter: true,
      });
    }
  };

  getOngoingSearchReport = () => {
    if (this.state.searchText) {
      professionalAction
        .getOngoingSearchReport(
          this.props.selectedDate,
          this.props.cityid,
          this.state.searchText,
          this.props.preventive_action
        )
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;
              this.setState({
                criminalList1: list,
                isLoading: false,
                total: criminal.totalItems,
              });
              this.isLoading = false;
            });
        });
      this.setState({
        criminalList1: [],
        filter: true,
      });
    }
  };

  getCompletedSearchReport = () => {
    if (this.state.searchText) {
      professionalAction
        .getCompletedSearchReport(
          this.props.selectedDate,
          this.props.cityid,
          this.state.searchText,
          this.props.preventive_action
        )
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;
              this.setState({
                criminalList1: list,
                isLoading: false,
                total: criminal.totalItems,
              });
              this.isLoading = false;
            });
        });
      this.setState({
        criminalList1: [],
        filter: true,
      });
    }
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page - 1 }, () => {
      if (this.state.filter) {
        if (
          (this.props && this.props?.report === true) ||
          this.props?.ongoing === true ||
          this.props?.completed === true
        ) {
          this.searchFilterReport(
            this.state.orderBy,
            this.state.orderDirection
          );
        } else {
          this.searchfilter(this.state.orderBy, this.state.orderDirection);
        }
      } else if (this.state.gunacount) {
        if (
          (this.props && this.props?.report === true) ||
          this.props?.ongoing === true ||
          this.props?.completed === true
        ) {
          this.filterGunaReport(this.state.orderBy, this.state.orderDirection);
        } else {
          this.getFilterByGunaCriminalsTableInfoByCityId(
            this.state.orderBy,
            this.state.orderDirection
          );
        }
      } else {
        if (
          (this.props && this.props?.report === true) ||
          this.props?.ongoing === true ||
          this.props?.completed === true
        ) {
          this.searchDataReport(this.state.searchText);
        } else {
          this.searchdata(this.state.searchText);
        }
      }
    });
  };

  handlePageSizeChange = (current, size) => {
    this.setState(
      {
        pageSize: size,
        currentPage: current,
      },
      () => {
        if (
          (this.props && this.props?.report === true) ||
          this.props?.ongoing === true ||
          this.props?.completed === true
        ) {
          this.searchDataReport(this.state.searchText);
        } else {
          this.searchdata(this.state.searchText);
        }
      }
    );
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentDidUpdate(prevProps) {
    // Check if the data has just arrived
    const prevList = prevProps.professionals?.criminalViewList?.gunhaInfor;
    const currList = this.props.professionals?.criminalViewList?.gunhaInfor;
    if (this.state.gunaLoading && prevList !== currList) {
      this.setState({ gunaLoading: false });
    }
  }
  handleEditForm = (data) => {
    if (this.props.isAccusedFormUpdate && this.props.isAccusedFormUpdate) {
      this.props.onEditAccusedForm(data);
    } else {
      this.props.onEdituser(data);
    }
  };

  handlePreventiveViewForm = (data) => {
    if (this.props.isAccusedFormUpdate && this.props.isAccusedFormUpdate) {
      this.props.onPreventiveViewAccusedForm(data);
    } else {
      this.props.onEdituser(data);
    }
    //this.props.onPreventiveViewAccusedForm(data);
  };

  handleViewForm = (data) => {
    this.props.onViewAccusedDetails(data);
  };

  handleActiveCriminal = (data) => {
    this.props.onCriminalActiveStatus(data);
  };

  onChangeTable = (pagination, filters, sorter, extra) => {};

  cleardata = () => {
    this.setState({
      criminalList1: [],
    });
  };

  searchfilter = (orderBy, orderDirection) => {
    this.isLoading = true;
    this.setState({
      orderBy: orderBy,
      orderDirection: orderDirection,
      isLoading: true,
    });
    if (this.state.searchText) {
      professionalAction
        .getFilterSearchCriminalsTableInfoByCityId(
          this.props.cityid,
          this.state.searchText,
          this.state.currentPage,
          this.state.pageSize,
          orderBy,
          orderDirection
        )
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.dataItem;
              this.setState({
                criminalList1: list,
                isLoading: false,
                total: criminal.totalItems,
              });
              this.isLoading = false;
            });
        });
      this.setState({
        criminalList1: [],
        filter: true,
      });
    } else {
      if (this.props.user.role === "4") {
        professionalAction
          .getFilterCriminalsTableInfoByCityId(
            this.props.cityid,
            this.state.currentPage,
            this.state.pageSize,
            orderBy,
            orderDirection
          )
          .then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.dataItem;
                this.setState({
                  criminalList1: list,
                  isLoading: false,
                  total: criminal.totalItems,
                });
                this.isLoading = false;
              });
          });
        this.setState({
          criminalList1: [],
          filter: true,
        });
      }
      if (this.props.user.role === "9" || this.props.user.role === "10") {
        const temp = {
          districtIds: this.props.user.map_districtId,
          page: this.state.currentPage,
          size: this.state.pageSize,
          orderBy: orderBy,
          orderDirection: orderDirection,
        };
        roleAction.getFilterCriminalsTableInfoByRole(temp).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.dataItem;
              this.setState({
                criminalList1: list,
                isLoading: false,
                total: criminal.totalItems,
              });
              this.isLoading = false;
            });
        });
        this.setState({
          criminalList1: [],
          filter: true,
        });
      }
    }
  };

  searchFilterReport = (orderBy, orderDirection) => {
    if (this.props?.report === true) {
      this.searchDefaultReport(orderBy, orderDirection);
    } else if (this.props?.ongoing === true) {
      this.searchOngoingReport(orderBy, orderDirection);
    } else if (this.props?.completed === true) {
      this.searchCompletedReport(orderBy, orderDirection);
    }
  };

  searchDefaultReport = (orderBy, orderDirection) => {
    // this.isLoading = true;
    this.setState({
      orderBy: orderBy,
      orderDirection: orderDirection,
      isLoading: true,
    });
    professionalAction
      .getFilterReport(
        this.props.startDate,
        this.props.endDate,
        this.props.cityid,
        orderBy,
        orderDirection,
        this.props.preventive_action
      )
      .then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            this.setState({
              criminalList1: list,
              isLoading: false,
              total: criminal.totalItems,
            });
            this.isLoading = false;
          });
      });
    this.setState({
      criminalList1: [],
      filter: true,
    });
  };

  searchOngoingReport = (orderBy, orderDirection) => {
    // this.isLoading = true;
    this.setState({
      orderBy: orderBy,
      orderDirection: orderDirection,
      isLoading: true,
    });
    professionalAction
      .searchOngoingReport(
        this.props.selectedDate,
        this.props.cityid,
        orderBy,
        orderDirection,
        this.props.preventive_action
      )
      .then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            this.setState({
              criminalList1: list,
              isLoading: false,
              total: criminal.totalItems,
            });
            this.isLoading = false;
          });
      });
    this.setState({
      criminalList1: [],
      filter: true,
    });
  };

  searchCompletedReport = (orderBy, orderDirection) => {
    // this.isLoading = true;
    this.setState({
      orderBy: orderBy,
      orderDirection: orderDirection,
      isLoading: true,
    });
    professionalAction
      .searchCompletedReport(
        this.props.selectedDate,
        this.props.cityid,
        orderBy,
        orderDirection,
        this.props.preventive_action
      )
      .then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            this.setState({
              criminalList1: list,
              isLoading: false,
              total: criminal.totalItems,
            });
            this.isLoading = false;
          });
      });
    this.setState({
      criminalList1: [],
      filter: true,
    });
  };

  getFilterByGunaCriminalsTableInfoByCityId = (orderBy, orderDirection) => {
    // this.isLoading = true;
    this.setState({
      orderBy: orderBy,
      orderDirection: orderDirection,
      isLoading: true,
    });
    professionalAction
      .getFilterByGunaCriminalsTableInfoByCityId(
        this.props.cityid,
        this.state.currentPage,
        this.state.pageSize,
        orderBy,
        orderDirection
      )
      // .then((res) => {
      //   res &&
      //     res.text().then((criminalList) => {
      //       let criminal = JSON.parse(criminalList);
      //       let list = criminal.results;
      //       console.log("criminal", criminal);
      //       // let list = criminal.dataItem;
      //       this.setState({
      //         criminalList1: list,
      //         tableLoading: false,
      //         total: criminal.totalCount,
      //       });
      //       // this.isLoading = false;
      //     });
      // });
      .then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            this.setState({
              criminalList1: list,
              isLoading: false,
              total: criminal.totalCount,
            });
            this.isLoading = false;
          });
      });
    this.setState({
      criminalList1: [],
      gunacount: true,
    });
  };

  filterkey = (e) => {
    this.setState({ key: e.key });
  };

  getSerialNumber = (index, currentPage, pageSize) => {
    return currentPage * pageSize + index + 1;
  };

  handleInputChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleSubTitleFind = async () => {
    this.setState({ isFilterActive: true, isLoading: true });
    console.log("Selected लघु शीर्ष:", this.state.selectedHeadings);
    const { selectedHeadings } = this.state;
    if (this.props.user.role === "4") {
      if (this.state.year.length > 0) {
        this.setState({
          is_year: true,
        });
      }

      const payload = {
        city: this.props.cityid,
        heading: selectedHeadings.length > 0 && selectedHeadings,
        year: this.state.year.length > 0 && this.state.year,
      };

      try {
        const response = await professionalAction.getGunainfoSubHeadingByFilter(
          payload
        );
        console.log("response", response);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("API Response:", data);
        this.setState({
          filterData: data.data,
          isLoading: false,
          total: data.data.length,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    if (this.props.user.role === "9" || this.props.user.role === "10") {
      if (this.state.year.length > 0) {
        this.setState({
          is_year: true,
        });
      }

      const payload = {
        districtIds: this.props.user.map_districtId,
        heading: selectedHeadings.length > 0 && selectedHeadings,
        year: this.state.year.length > 0 && this.state.year,
      };

      try {
        const response = await roleAction.getCriminalsHeadingFilterByRole(
          payload
        );
        console.log("response", response);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("API Response:", data);
        this.setState({
          filterData: data.data,
          isLoading: false,
          total: data.data.length,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  handleKala = (e) => {
    this.setState({
      kayda: e,
    });
    this.props.dispatch(professionalAction.getKalam(e));
  };

  handleTitleFind = async () => {
    this.setState({ isFilterActive: true, isLoading: true });
    console.log("props of find accessed ", this.props.user.role);
    console.log("Selected शीर्षक:", this.state.crimeTitle);
    const { crimeTitle } = this.state;
    if (this.props.user.role === "4") {
      if (this.state.year.length > 0) {
        this.setState({
          is_year: true,
        });
      }
      const payload = {
        cityId: this.props.cityid,
        heading: crimeTitle.length > 0 && crimeTitle,
        year: this.state.year.length > 0 && this.state.year,
        searchText:
          this.state.select_dropdown === "search_guna" && this.state.searchGuna,
        searchId:
          this.state.select_dropdown === "search_id" && this.state.searchGuna,
        rulesName: this.state.kayda,
        kalam: this.state.kalam,
        crime_title:
          this.state.selectedFilter === "मोडस" &&
          this.state.crime_type.length > 0 &&
          this.state.crime_type,
      };

      try {
        const response = await professionalAction.getGunhaInfoByFilter(payload);
        console.log("response", response);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Response Data:", data);
        this.setState({
          filterData: data?.results,
          isLoading: false,
          total: data?.results.length,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    if (this.props.user.role === "9" || this.props.user.role === "10") {
      if (this.state.year.length > 0) {
        this.setState({
          is_year: true,
        });
      }
      const payload = {
        districtIds: this.props.user.map_districtId,
        heading: crimeTitle.length > 0 && crimeTitle,
        year: this.state.year.length > 0 && this.state.year,
        searchText:
          this.state.select_dropdown === "search_guna" && this.state.searchGuna,
        searchId:
          this.state.select_dropdown === "search_id" && this.state.searchGuna,
        rulesName: this.state.kayda,
        kalam: this.state.kalam,
        crime_title:
          this.state.selectedFilter === "मोडस" &&
          this.state.crime_type.length > 0 &&
          this.state.crime_type,
      };

      try {
        const response = await roleAction.getGunaHeadingArophiFilterByRole(
          payload
        );
        console.log("response", response);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Response Data:", data);
        this.setState({
          filterData: data?.results,
          isLoading: false,
          total: data?.results.length,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  handleYear = (e) => {
    this.setState({ year: e });
  };
  getGunaWiseYear = async () => {
    this.setState({
      filterData: [],
      isLoading: true,
      isFilterActive: true,
      is_year: true,
    });
    if (this.props.user.role == "4") {
      const temp = {
        cityId: this.props.user.cityId,
        year: this.state.year,
      };
      professionalAction.getGunaWiseYear(temp).then((res) => {
        res &&
          // let criminal = JSON.parse(criminalList1);
          // let list = criminal.dataItem;
          this.setState({
            filterData: res.results,
            isLoading: false,
            total: res?.results?.length,
          });
      });
    }
    if (this.props.user.role == "9" || this.props.user.role === "10") {
      const temp = {
        districtIds: this.props.user.map_districtId,
        year: this.state.year,
      };

      const response = await roleAction.gunaYearWiseByRole(temp);
      console.log("response", response);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Response Data:", data);
      this.setState({
        filterData: data?.results,
        isLoading: false,
      });
    }
  };
  handlePhoto = (e) => {
    this.setState({
      photoStatus: e.target.value,
    });
  };
  getPhotoStatusFilterByCity = () => {
    this.setState({ isFilterActive: true });
    const { photoStatus } = this.state;
    this.setState({
      isLoading: true,
    });

    const payload = {
      city: this.props.user.role === "4" && this.props.user.cityId,
      photo_status: photoStatus,
    };
    professionalAction.getPhotoStatusFilterByCity(payload).then((res) => {
      this.setState({
        filterData: res.rows,
        isLoading: false,
        total: res.count,
      });
    });
  };

  onchangeSearch = (e) => {
    this.setState({
      select_dropdown: e,
      searchText: "",
      searchGuna: "",
    });
  };

  showDownloadPopup = () => {
    this.setState({
      is_download: true,
    });
  };
  closeDownloadPopup = () => {
    this.setState({
      is_download: false,
    });
  };
  getMainHead = () => {
    professionalAction.getMainHead().then((res) => {
      console.log("res", res.data);
      this.setState({
        main_head: res.data,
      });
    });
  };
  getCrimeTitleByTitleId = (id) => {
    professionalAction.getCrimeTitleByTitleId(id).then((res) => {
      console.log("res", res.pc_crimeTypes);
      this.setState({
        crime_type: res.pc_crimeTypes,
      });
    });
  };

  handleMainHead = (e) => {
    this.setState({ select_main_head: e });
    this.getCrimeTitleByTitleId(e);
  };
  render() {
    const {
      selectedHeadings,
      crimeTitle,
      selectedFilter,
      data,
      criminalList1,
      is_photo,
      photoStatus,
      select_dropdown,
      key,
      orderDirection,
    } = this.state;
    const { pc_crimetypes, pc_crimetitles } = this.props;
    console.log("pc_crimetitles", pc_crimetitles);
    console.log("criminalList1", criminalList1);
    console.log("data", data);
    const requiredSerchColumn = ["mobileNumber", "name", "districtName"];
    const { t } = this.context;
    const { professionals, user } = this.props;
    const { year } = this.state;

    // Generate year options from 2010 to current year
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let y = 2010; y <= currentYear; y++) {
      yearOptions.push(y);
    }
    // const requiredSortColumn = ["age"];
    // const requiredSearchAndSort = ["name", "districtName", "address"];
    // const requiredFilterColumn = ["photo"];
    const users = this.props.usersData;
    let columns = this.props.columns.map((res) => {
      return {
        ...res,
      };
    });
    const nameColumn = {
      title: t("name"),
      key: "name",
      render: (text, record) => <span title={record.id}>{record.name}</span>,
    };

    const srNoIndex = columns.findIndex((col) => col.key === "Sr.No");

    // Insert the name column after "Sr.No"
    if (srNoIndex !== -1) {
      columns.splice(srNoIndex + 1, 0, nameColumn);
    } else {
      // Fallback: if "Sr.No" not found, push at the end
      columns.push(nameColumn);
    }

    columns.push({
      title: t("total_crimes"),
      key: "total_count",
      render: (text, record) => (
        <div className="action-links-responsive">
          <Button
            type="text"
            size="small"
            className="action-link update-link"
            onClick={() => {
              this.onGunaForm(record.id);
            }}
          >
            {record.gunhaCount}
          </Button>
        </div>
      ),
    });
    columns.push({
      ...{
        title: t("photo"),
        key: "photo",
        // filters: [
        //   {
        //     text: "फोटो",
        //     value: 1,
        //   },
        //   {
        //     text: "नाही",
        //     value: null,
        //   },
        // ],
        onFilter: (value, record) => {
          if (value) {
            return record.photo ? record.photo.split().length === value : null;
          } else {
            return record.photo === value;
          }
        },
        render: (text, record) => (
          <Space size="middle">
            {record.photo ? (
              <img
                style={{ width: 50, height: 50 }}
                src={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                  record.photo
                }
                onClick={() => this.openImageModal(record.photo, record.name)}
              ></img>
            ) : (
              "नाही"
            )}
          </Space>
        ),
      },
    });

    columns.push({
      ...{
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handleEditForm(record);
              }}
            >
              {t("update")}
            </Button>

            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handleViewForm(record.id);
              }}
            >
              {t("view1")}
            </Button>

            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handlePreventiveViewForm(record.id);
              }}
            >
              {t("preventive")}
            </Button>

            {users.cityId === record.city ? (
              this.props.report == true ? (
                ""
              ) : this.props.user.role === "9" ||
                this.props.user.role === "10" ? (
                ""
              ) : (
                <Button
                  type="text"
                  size="small"
                  className="action-link update-link"
                  onClick={() => {
                    this.handleActiveCriminal(record);
                  }}
                >
                  {record.activeUser && record.activeUser === 1 ? (
                    <Tag color="green">{t("active")} </Tag>
                  ) : (
                    <Tag color="red">{t("in_active")}</Tag>
                  )}
                </Button>
              )
            ) : (
              ""
            )}
          </div>
        ),
      },
    });

    const menu = (
      <Menu onClick={this.filterkey}>
        <Menu.Item key="name">
          {t("sort_by_name")}
          <ArrowDownOutlined
            style={{
              color:
                key === "name" && orderDirection === "ASC"
                  ? "#1890ff"
                  : "#bfbfbf",
            }}
            onClick={() => {
              this.searchfilter("name", "ASC");
            }}
          ></ArrowDownOutlined>
          <ArrowUpOutlined
            style={{
              color:
                key === "name" && orderDirection === "DESC"
                  ? "#1890ff"
                  : "#bfbfbf",
            }}
            onClick={() => {
              this.searchfilter("name", "DESC");
            }}
          />
        </Menu.Item>
        <Menu.Item key="age">
          {t("sort_by_age")}
          <ArrowDownOutlined
            style={{
              color:
                key === "age" && orderDirection === "ASC"
                  ? "#1890ff"
                  : "#bfbfbf",
            }}
            onClick={() => {
              this.searchfilter("age", "ASC");
            }}
          ></ArrowDownOutlined>
          <ArrowUpOutlined
            style={{
              color:
                key === "age" && orderDirection === "DESC"
                  ? "#1890ff"
                  : "#bfbfbf",
            }}
            onClick={() => {
              this.searchfilter("age", "DESC");
            }}
          />
        </Menu.Item>
        <Menu.Item key="districtName">
          {t("sort_by_police_station")}
          <ArrowDownOutlined
            style={{
              color:
                key === "districtName" && orderDirection === "ASC"
                  ? "#1890ff"
                  : "#bfbfbf",
            }}
            onClick={() => {
              this.searchfilter("districtName", "ASC");
            }}
          ></ArrowDownOutlined>
          <ArrowUpOutlined
            style={{
              color:
                key === "districtName" && orderDirection === "DESC"
                  ? "#1890ff"
                  : "#bfbfbf",
            }}
            onClick={() => {
              this.searchfilter("districtName", "DESC");
            }}
          />
        </Menu.Item>
        {/* <Menu.Item key="totalCrimeCount">
          {t("sort_by_total_crimes")}
          <ArrowDownOutlined
            style={{
              color:
                key === "gunhaCount" && orderDirection === "ASC" ? "#1890ff" : "#bfbfbf",
            }}
            onClick={() => {
              this.searchfilter("gunhaCount", "ASC");
            }}
          ></ArrowDownOutlined>
          <ArrowUpOutlined
            style={{
              color:
                key === "gunhaCount" && orderDirection === "DESC" ? "#1890ff" : "#bfbfbf",
            }}
            onClick={() => {
              this.searchfilter("gunhaCount", "DESC");
            }}
          />
        </Menu.Item> */}
      </Menu>
    );

    let total = this.state.total
      ? this.state.total
      : this.props.data.length > 0
      ? this.props.total
      : "0";
    return (
      <>
        <div className="filter-card">
          {/* First Row - Search + Photo */}
          <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 12 }}>
            {/* Filter Dropdown */}
            <Col xs={24} sm={6} md={4}>
              <Select
                onChange={(e) => this.onchangeSearch(e)}
                value={select_dropdown}
                placeholder={t("select_filter_type")}
                allowClear
                style={{ width: "100%" }}
              >
                <Option value="search_name">{t("search_by_name")}</Option>
                <Option value="search_guna">{t("search_by_guna")}</Option>
                <Option value="search_id">{t("search_by_id")}</Option>
              </Select>
            </Col>

            {/* Search Input Area */}
            <Col xs={24} sm={10} md={12}>
              {select_dropdown === "search_name" && (
                <>
                  <Input
                    placeholder={t("search")}
                    value={this.state.searchText}
                    onChange={this.handleInputChange}
                    style={{
                      width: "200px",
                      borderRadius: "6px",
                      height: "36px",
                    }}
                    // allowClear
                  />
                  <Button
                    type="primary"
                    onClick={(e) => {
                      if (
                        (this.props && this.props?.report === true) ||
                        this.props?.ongoing === true ||
                        this.props?.completed === true
                      ) {
                        this.searchDataReport(this.state.searchText);
                      } else {
                        this.searchdata();
                      }
                    }}
                    style={{
                      height: "36px",
                      borderRadius: "6px",
                      minWidth: "80px",
                      marginLeft: "10px",
                    }}
                  >
                    {t("search")}
                  </Button>
                  {this.state.issearch && (
                    <Button
                      onClick={(e) => this.clear()}
                      className="modern-button modern-button-danger"
                    >
                      {t("clear")}
                    </Button>
                  )}
                </>
              )}

              {select_dropdown === "search_guna" && (
                <Space style={{ width: "100%", gap: 8 }} wrap>
                  <Input
                    placeholder={t("search_cr_no")}
                    value={this.state.searchGuna}
                    onChange={(e) =>
                      this.setState({ searchGuna: e.target.value })
                    }
                    allowClear
                    style={{ flexGrow: 1 }}
                  />
                  {this.state.searchGuna.trim() !== "" && (
                    <Button
                      type="primary"
                      onClick={() => this.handleTitleFind()}
                    >
                      {t("find")}
                    </Button>
                  )}
                </Space>
              )}

              {select_dropdown === "search_id" && (
                <Space style={{ width: "100%", gap: 8 }} wrap>
                  <Input
                    placeholder={t("search_id")}
                    value={this.state.searchGuna}
                    onChange={(e) =>
                      this.setState({ searchGuna: e.target.value })
                    }
                    onKeyPress={(event) => {
                      if (!/^[0-9\u0966-\u096F]$/.test(event.key))
                        event.preventDefault();
                    }}
                    onPaste={(event) => {
                      const pastedText = event.clipboardData.getData("Text");
                      if (!/^[0-9\u0966-\u096F]+$/.test(pastedText))
                        event.preventDefault();
                    }}
                    allowClear
                    maxLength={10}
                    style={{ flexGrow: 1 }}
                  />
                  {this.state.searchGuna.trim() !== "" && (
                    <Button
                      type="primary"
                      onClick={() => this.handleTitleFind()}
                    >
                      {t("find")}
                    </Button>
                  )}
                </Space>
              )}
            </Col>
            {(this.props.user.role === "9" ||
              this.props.user.role === "10") && (
              <Col xs={24} sm={8} md={8}>
                <Space
                  wrap
                  style={{
                    width: "100%",
                    justifyContent: "flex-end",
                    gap: 8,
                  }}
                >
                  <Dropdown
                    overlay={menu}
                    placement="bottomRight"
                    arrow={{ pointAtCenter: true }}
                    style={{
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button type="default">{t("sorter_by")}</Button>
                  </Dropdown>
                </Space>
              </Col>
            )}
          </Row>

          {/* Second Row - Full Width Filters */}
          <Row gutter={[16, 16]} style={{ marginTop: 12 }}>
            <Col span={24}>
              <Row gutter={[16, 16]} justify="space-between" align="middle">
                <Col xs={24} lg={18}>
                  <Space wrap style={{ width: "100%" }}>
                    <span className="filter-label">
                      {t("select_filter_type")}:
                    </span>
                    <Select
                      placeholder={t("select_filter_type")}
                      value={selectedFilter}
                      onChange={(val) =>
                        this.setState({
                          selectedFilter: val,
                          select_dropdown: null,
                        })
                      }
                      style={{ minWidth: 140, flex: 1 }}
                      allowClear
                      disabled={
                        this.state.is_photo ||
                        this.state.issearch == true ||
                        this.state.filter == true ||
                        this.state.is_guna == true
                      }
                    >
                      <Option value="शीर्षक">{t("title")}</Option>
                      <Option value="लघु शीर्षक">{t("sub_title")}</Option>
                      <Option value="मोडस">{t("modus_operandi")}</Option>
                      <Option value="कायदा">
                        {`${t("law")} / ${t("section")}`}
                      </Option>
                    </Select>

                    {selectedFilter === "लघु शीर्षक" && (
                      <Select
                        mode="multiple"
                        placeholder="Please select Crime Type"
                        value={selectedHeadings}
                        onChange={(val) =>
                          this.setState({ selectedHeadings: val })
                        }
                        style={{ minWidth: 220, flex: 1 }}
                        showSearch
                        maxTagCount={1}
                      >
                        {pc_crimetypes?.map((res) => (
                          <Option key={res.id} value={res.id}>
                            {res.crimetype}
                          </Option>
                        ))}
                      </Select>
                    )}

                    {selectedFilter === "शीर्षक" && (
                      <Select
                        mode="multiple"
                        allowClear
                        placeholder={t("please_select_a_title")}
                        value={crimeTitle}
                        onChange={(val) => this.setState({ crimeTitle: val })}
                        style={{ minWidth: 220, flex: 1 }}
                        showSearch
                        maxTagCount={1}
                      >
                        {pc_crimetitles?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.crime_title}
                          </Option>
                        ))}
                      </Select>
                    )}
                    {selectedFilter === "कायदा" && (
                      <Select
                        allowClear
                        placeholder={t("please_select_an_option")}
                        value={this.state.kayda}
                        onChange={(val) => this.handleKala(val)}
                        style={{ minWidth: 220, flex: 1 }}
                        showSearch
                        maxTagCount={1}
                        filterOption={(input, option) =>
                          option?.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {professionals?.pc_acts?.map((item) => (
                          <Option key={item.act_cd} value={item.act_cd}>
                            {item.kayda}
                          </Option>
                        ))}
                      </Select>
                    )}
                    {this.state.kayda && selectedFilter === "कायदा" && (
                      <Select
                        filterOption={(input, option) =>
                          option?.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        optionFilterProp="children"
                        mode="multiple"
                        allowClear
                        placeholder="Please select option"
                        value={this.state.kalam}
                        onChange={(val) => this.setState({ kalam: val })}
                        style={{ minWidth: 220, flex: 1 }}
                        showSearch
                        maxTagCount={1}
                      >
                        {professionals?.pc_kalams?.map((item) => (
                          <Option key={item.section} value={item.section}>
                            {item.section}
                          </Option>
                        ))}
                      </Select>
                    )}
                    {selectedFilter === "मोडस" && (
                      <Select
                        filterOption={(input, option) =>
                          option?.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        mode="multiple"
                        optionFilterProp="children"
                        allowClear
                        placeholder="Please select option"
                        value={this.state.crime_type}
                        onChange={(val) => this.setState({ crime_type: val })}
                        style={{ minWidth: 220, flex: 1 }}
                        showSearch
                        maxTagCount={1}
                      >
                        {this.state.main_head?.map((item) => (
                          <Option key={item.title_id} value={item.title_id}>
                            {item.main_head_type}
                          </Option>
                        ))}
                      </Select>
                    )}

                    <Select
                      mode="multiple"
                      allowClear
                      placeholder={t("crimes_year")}
                      value={year}
                      onChange={(val) => this.handleYear(val.map(Number))}
                      style={{ minWidth: 140, flex: 1 }}
                      showSearch
                      maxTagCount={1}
                      disabled={
                        this.state.is_photo ||
                        this.state.issearch == true ||
                        this.state.filter == true ||
                        this.state.is_guna == true
                      }
                    >
                      {yearOptions.map((y) => (
                        <Option key={y} value={y}>
                          {y}
                        </Option>
                      ))}
                    </Select>
                  </Space>
                </Col>

                <Col xs={24} lg={6} style={{ textAlign: "right" }}>
                  {(this.state.year.length > 0 ||
                    this.state.crimeTitle.length > 0 ||
                    this.state.selectedHeadings.length > 0 ||
                    this.state.kalam.length > 0 ||
                    this.state.crime_type.length > 0) && (
                    <Button
                      type="primary"
                      className="modern-button modern-button-success"
                      onClick={
                        this.state.selectedFilter === "शीर्षक" ||
                        this.state.selectedFilter === "मोडस"
                          ? this.handleTitleFind
                          : this.state.selectedFilter === "लघु शीर्षक"
                          ? this.handleSubTitleFind
                          : this.handleTitleFind
                      }
                    >
                      {t("find")}
                    </Button>
                  )}
                  {(this.state.is_year || this.state.isFilterActive) && (
                    <Button
                      className="modern-button modern-button-danger"
                      onClick={() => this.clearFilter()}
                      style={{ marginLeft: 8 }}
                    >
                      {t("clear")}
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Third Row - Download */}
          <Row gutter={[16, 16]} style={{ marginTop: 12 }}>
            <Col span={24}>
              <Space wrap>
                <Form
                  ref={this.formRef}
                  onFinish={this.handleFinish}
                  initialValues={{ condition: this.state.download }}
                >
                  <Form.Item
                    name="condition"
                    rules={[
                      {
                        required: true,
                        message: "Please select a value",
                      },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    <Select
                      placeholder="Please select an option"
                      value={this.state.download} // controlled by state
                      onChange={this.handleChange} // updates state + Form
                      style={{ minWidth: 160 }}
                    >
                      <Option value="excel">{t("excel")}</Option>
                      <Option value="guna_excel">
                        {t("crime_statistics")}
                      </Option>
                    </Select>
                  </Form.Item>
                </Form>

                {this.state.download && (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (
                        !this.state.selectedFilter &&
                        this.state.filterData.length === 0
                      ) {
                        this.showDownloadPopup();
                      } else {
                        this.downloadReport();
                      }
                    }}
                  >
                    {t("download")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>
        </div>

        {/* <div className="filter-row-responsive">
              <Button
                onClick={() => {
                  this.setState({
                    is_photo: true,
                  });
                }}
              >
                photo
              </Button>
              {this.state.is_photo && (
                <Radio.Group
                  value={photoStatus}
                  optionType="button"
                  buttonStyle="solid"
                  onChange={(e) => {
                    this.handlePhoto(e);
                  }}
                >
                  <Radio.Button
                    value="yes"
                    style={{
                      backgroundColor: photoStatus === "yes" ? "#52c41a" : "",
                      color: photoStatus === "yes" ? "#fff" : "",
                      borderColor: photoStatus === "yes" ? "#52c41a" : "",
                    }}
                  >
                    {t("yes")}
                  </Radio.Button>
                  <Radio.Button
                    value="no"
                    style={{
                      backgroundColor: photoStatus === "no" ? "#f5222d" : "",
                      color: photoStatus === "no" ? "#fff" : "",
                      borderColor: photoStatus === "no" ? "#f5222d" : "",
                    }}
                  >
                    {t("no")}
                  </Radio.Button>
                </Radio.Group>
              )}
              {photoStatus && this.state.is_photo && (
                <>
                  <Button
                    type="primary"
                    className="modern-button modern-button-success"
                    onClick={this.getPhotoStatusFilterByCity}
                  >
                    {t("find")}
                  </Button>
                  {this.state.isFilterActive && (
                    <Button
                      onClick={(e) => {
                        this.clearFilter();
                      }}
                      className="modern-button modern-button-danger"
                    >
                      {t("clear")}
                    </Button>
                  )}
                </>
              )}
            </div> */}
        <div
          style={{
            padding: "4px 12px",
            background: "#fff",
            borderRadius: "4px",
            border: "1px solid #d9d9d9",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            width: "8%",
            marginBottom: "10px",
          }}
        >
          <span style={{ color: "#666" }}>{t("total")}:</span>
          <span style={{ fontWeight: "bold" }}>{total}</span>
        </div>

        {this.state.search == true ||
        this.state.filter == true ||
        this.state.gunacount == true ? (
          <FindAccusedBaseSearchTable
            search={this.state.searchText}
            clear={this.clear}
            isAccusedFormUpdate={true}
            onEditAccusedForm={this.handleEditForm}
            onPreventiveViewAccusedForm={this.handlePreventiveViewForm}
            onViewAccusedDetails={this.handleViewForm}
            onCriminalActiveStatus={this.handleActiveCriminal}
            criminalRecords={this.state.criminalList1}
            columns={columns}
            usersData={this.props.usersData}
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.state.total}
            handlePageChange={this.handlePageChange}
            handlePageSizeChange={this.handlePageSizeChange}
            isseach={this.props.isseach}
            cityid={users.cityId ? users.cityId : this.props.cityid}
            cleardata={this.cleardata}
            getSerialNumber={this.getSerialNumber}
            loading={this.state.isLoading}
            professionals={professionals}
            user={this.props?.user}
          />
        ) : this.state.isFilterActive == true ? (
          <FilterData
            clear={this.clear}
            isAccusedFormUpdate={true}
            onEditAccusedForm={this.handleEditForm}
            onPreventiveViewAccusedForm={this.handlePreventiveViewForm}
            onViewAccusedDetails={this.handleViewForm}
            onCriminalActiveStatus={this.handleActiveCriminal}
            criminalRecords={this.state.filterData}
            columns={columns}
            usersData={this.props.usersData}
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.state.total}
            handlePageChange={this.handlePageChange}
            handlePageSizeChange={this.handlePageSizeChange}
            isseach={this.props.isseach}
            cityid={users.cityId ? users.cityId : this.props.cityid}
            cleardata={this.cleardata}
            getSerialNumber={this.getSerialNumber}
            loading={this.state.isLoading}
            professionals={professionals}
            isFilterActive={this.state.isFilterActive}
            selectedFilter={this.state.selectedFilter}
            is_year={this.state.is_year}
            user={this.props?.user}
          ></FilterData>
        ) : (
          <Spin spinning={this.props.loading}>
            <Table
              columns={columns}
              dataSource={this.props.data}
              pagination={{
                current: this.props.currentPage,
                pageSize: this.props.pageSize,
                total: this.props.total,
                onChange: this.props.handlePageChange,
                has_previous: this.props.pageSize > 1,
                previous: this.props.pageSize - 1,
                has_next: this.props.pageSize < this.props.total,
                next: this.props.total + 1,
                last_page: Math.ceil(this.props.total / this.props.pageSize),
                onShowSizeChange: this.props.handlePageSizeChange,
                // showSizeChanger: true,
                // showQuickJumper: true,
              }}
            />
          </Spin>
        )}
        {this.state.imageOpen && (
          <ImageView
            imageOpen={this.state.imageOpen}
            imageUrl={
              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
              this.state.selectedImage
            }
            name={this.state.name}
            onClose={this.closeImageModal}
          />
        )}
        {this.state.is_download && (
          <Modal
            title="Confirm"
            open={this.state.is_download} // use `open` instead of deprecated `visible`
            onOk={this.closeDownloadPopup}
            onCancel={this.closeDownloadPopup}
            centered
            width="90%" // default responsive width
            style={{ maxWidth: 600 }} // ensures modal doesn’t get too wide
            bodyStyle={{ wordWrap: "break-word" }}
          >
            <p style={{ fontSize: "1rem", textAlign: "center" }}>
              कृपया किमान एक <b>शीर्षक</b> किंवा <b>लघु शीर्षक</b> किंवा{" "}
              <b>कायदा/कलम</b> किंवा
              <b>गुन्हा दाखल वर्ष</b> निवडा
            </p>
          </Modal>
        )}
        <Modal
          title={t("crime_information")}
          top
          visible={this.state.showGunaDetails}
          onOk={this.closeGunaViewModel}
          onCancel={this.closeGunaViewModel}
          width={95 + "%"}
        >
          <ViewGunaDetails
            pc_crimetitles={professionals?.pc_crimetitles}
            dataStates={
              Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
              professionals?.criminalViewList?.gunhaInfor.length > 0
                ? professionals?.criminalViewList?.gunhaInfor
                : []
            }
            address={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].address
                : ""
            }
            name={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].name
                : ""
            }
            loading={this.state.gunaLoading}
            user_details={this.props?.user}
            masterId={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].id
                : ""
            }
            closeGunaViewModel={this.closeGunaViewModel}
          ></ViewGunaDetails>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const FindAccusedBaseTableForm = connect(mapStateToProps)(FindAccusedBaseTable);
export { FindAccusedBaseTableForm as FindAccusedBaseTable };
